export const CHANGE_HISTORY = {
  BACK: 'Back',
  DOWNLOAD_CSV: 'Download CSV',
  MANUAL_URLS: 'Manual URLs',
};
